import { DocData } from './doc-data';

export const recoveryStrategies: DocData = {
  titleKey: 'docs.recoveryStrategies.title',
  descriptionKey: 'docs.recoveryStrategies.description',
  route: 'recovery',
  iconSvg: `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
         viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round"
         class="lucide lucide-life-buoy h-10 w-10 text-bcm-success">
      <circle cx="12" cy="12" r="10"></circle>
      <path d="m4.93 4.93 4.24 4.24"></path>
      <path d="m14.83 9.17 4.24-4.24"></path>
      <path d="m14.83 14.83 4.24 4.24"></path>
      <path d="m9.17 14.83-4.24 4.24"></path>
      <circle cx="12" cy="12" r="4"></circle>
    </svg>
  `,
  tooltipShortKey: 'docs.recoveryStrategies.tooltipShort',
  tooltipLinkKey: 'docs.recoveryStrategies.tooltipLink'
};
